import { Action, createReducer, on } from "@ngrx/store";
import { CheckoutActions } from "../actions";
import { CheckoutIncotermState } from "../checkout.state";

const initialState: CheckoutIncotermState = {
    loading: null,
    success: null,
    error: null,
    incotermOptions: [],
};

const checkoutIncotermReducer = createReducer(
    initialState,
    on(
        CheckoutActions.loadIncoterm,
        (state: CheckoutIncotermState) => ({
            ...state,
            loading: true,
            success: null,
            error: null,
        })
    ),
    on(
        CheckoutActions.loadIncotermSuccess,
        (state: CheckoutIncotermState, { payload }) => ({
            ...state,
            loading: null,
            success: true,
            error: null,
            incotermOptions: payload
        })
    ),
    on(
        CheckoutActions.loadIncotermFail,
        (state: CheckoutIncotermState, { payload }) => ({
            ...state,
            loading: null,
            success: null,
            error: payload
        })
    ),
    on(
        CheckoutActions.updateIncotermSuccess,
        (state: CheckoutIncotermState) => ({
            ...state,
            loading: null,
            error: null,
        })
    ),
    on(
        CheckoutActions.updateIncotermFail,
        (state: CheckoutIncotermState, { payload }) => ({
            ...state,
            loading: null,
            error: payload,
        })
    ),
    on(
        CheckoutActions.clearCheckoutState,
        () => ({ ...initialState })
    )
);

export function reducer(state: CheckoutIncotermState | undefined, action: Action) {
    return checkoutIncotermReducer(state, action);
}